<rt-button
  #dropdownTrigger="rtOverlayOrigin"
  [disabled]="disabled"
  [dropdownOpened]="state.dropdownOpen"
  (click)="toggleDropdown()"
  variant="tertiary"
  rt-overlay-origin
>
  {{ buildText(label()) }}
</rt-button>

<ng-template
  #dropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [open]="state.dropdownOpen"
  [origin]="dropdownTrigger"
  [minWidth]="'210px'"
  (backdropClick)="toggleDropdown()"
>
  <rt-dropdown>
    @for (option of state.activeOptions; track trackByOption($index, option)) {
      <rt-dropdown-item (click)="selectOption(option)">
        {{ buildText($any(option).label) }}
      </rt-dropdown-item>
    }
  </rt-dropdown>
</ng-template>
